export enum Themes {
  Primary = 'primary',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Purple = 'purple',
}
